import { action, computed, observable, reaction, makeObservable } from 'mobx';
import {
    Control,
    Disposers,
    HttpPromiseState,
    StringControl,
    validators
} from '../../../../lib/helpers';
import { PagedListResponse, pagedListResponseUtils } from '../../../../domain';
import {
    Classroom,
    ClassroomSearchDto,
    ClassroomStatus,
    ClassroomUserFilter
} from '../../../classroom/models/classroom-models';
import { ClassroomLoaders } from '../../../classroom/stores/classroom-loaders';

const U = pagedListResponseUtils;

export class ChangeTimeSuggestionStore {
    @observable
    currentPage: number;

    @observable.ref
    resultState: HttpPromiseState<PagedListResponse<Classroom>> | null;

    private readonly disposers = new Disposers();

    constructor(private roomId: number) {
        makeObservable(this);
        this.currentPage = 0;
        this.resultState = null;
        this.setup();
    }

    @action
    load = () => {
        if (this.resultState?.isPending === true)
            return;
        this.resultState = ClassroomLoaders.Admin.getChangeTimeSuggestions(this.currentPage);
    };

    @computed
    get hasPreviousPage(): boolean {
        if (this.resultState?.isResolved !== true)
            return false;
        return U.hasPreviousPage(this.resultState.value);
    }

    @action
    loadPreviousPage = () => {
        this.currentPage--;
        this.load();
    };

    @computed
    get hasNextPage(): boolean {
        if (this.resultState?.isResolved !== true)
            return false;
        return U.hasNextPage(this.resultState.value);
    }

    @action
    loadNextPage = () => {
        this.currentPage++;
        this.load();
    };

    private setup() {
        this.disposers.add(
            reaction(
                () => [this.resultState?.value],
                this.updateCurrentPage
            ));
            this.load();
    }

    @action
    private updateCurrentPage = () => {
        if (this.resultState?.isResolved !== true)
            return;
        this.currentPage = this.resultState.value.CurrentPage;
    };

    dispose = () => {
        this.disposers.dispose();
    };
}